import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import arrow from "../../images/arrow.png";
import fitz_HoopsImg from '../../images/Fitz_Hoops.png';
import "../../styles.css";

export default function JoinRoom() {
    const [user, setUser] = useState("");
    const [room, setRoom] = useState("");
    const navigate = useNavigate();

    const joinGame = () => {
        if (user != "" && room != "") {
            navigate('/room', {
                state: {
                    user: user,
                    code: room
                }
            })
        };
    };

    return (
        <div className="JoinRoom">
            <div className="container d-flex justify-content-center">
                <div className="row">
                    <div className="col-sm-6">
                        <h1>
                            Before you join...
                        </h1>
                        <div className="name">
                            <h2>
                                What's your name?
                            </h2>
                            <input
                            type=""
                            placeholder="ex. Skete"
                            autoFocus="on"
                            autoComplete="off"
                            value={user}
                            onChange={(e) => setUser(e.target.value)}
                            />                
                        </div>
                        <div className="fourLetter">
                            <h2>
                                What's your four-letter code?
                            </h2>
                            <input
                            type=""
                            placeholder="ex. 1234"
                            autoFocus="on"
                            autoComplete="off"
                            value={room}
                            onChange={(e) => setRoom(e.target.value)}
                            />                
                        </div>
                        <span className="d-flex justify-content-between">
                            <button className="Join btn btn-dark btn-lg mt-5" onClick={joinGame}>
                                Join
                            </button>
                            <button className="arrow btn btn-dark mt-5" onClick={() => navigate('/')}>
                                <img src={arrow} alt="back arrow" />
                            </button>                                                           
                        </span>
                    </div>
                    <div className="col-sm-6">
                        <img src={fitz_HoopsImg} alt="fitz hoops" />
                    </div>
                </div>
            </div>
        </div>
    );
}